import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';

const TankDetailCard = ({ className, name }) => (
  <Card className={cn(className, 'pa3')}>
    <div>
      <h3 className="f4 mt0">{name}</h3>
    </div>
  </Card>
);

export default TankDetailCard;



// WEBPACK FOOTER //
// ./src/components/tankDetailCard/tankDetailCard.jsx